<template>
    <div :class="styleClass.container" @click="redirectToPage">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <h2 class="title" v-text="notification.title"></h2>
                <div class="description text-muted" v-text="notification.content"></div>
                <div class="description text-muted" v-text="displayedNotifiedDate"></div>
                <div class="text-right mt-2">
                        <a v-if="!isRequesting" href="/mark-as-read" @click.prevent="toggleRead" class="btn-link btn-sm link-hover-line mr-3">
                            <template v-if="!isRead">
                                <i class="fa fa-eye mr-2"></i> Mark as read
                            </template>
                            <template v-else>
                                <i class="fa fa-eye mr-2"></i> Mark as unread
                            </template>
                        </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import mixins from "@utils/mixins";
import { route, patch } from "@utils/network";
import { getRoute } from "./notification-routes";

export default {
    name: "NotificationListItem",

    computed: {
        isRead() {
            return !!this.notification.read_at;
        },
        displayImage() {
            return this.notification.image ? this.notification.image : "/images/placeholders/avatar.jpg";
        },
        styleClass() {
            return {
                container: {
                    "pointer": true,
                    "col-sm-12": true,
                    "list-content-item": true,
                    "unread": !this.isRead,
                },
            }
        },
        displayedNotifiedDate() {
            return this.notification.created_at_difference;
        },
    },

    data() {
        return {
            notification: {},
            isRequesting: false,
        }
    },

    methods: {
        toggleRead() {
            this.isRequesting = true;
            const request = this.isRead
                ? patch(route("notifications/:id/unread", { id: this.notification.id }))
                : patch(route("notifications/:id/read", { id: this.notification.id }));

            request.then(response => this.markAsRead(response))
                .catch(error => this.failedToMarkAsRead(error))
                .finally(() => this.isRequesting = false);
        },
        markAsRead(response) {
            this.notification = response.data.result.notification;
        },
        failedToMarkAsRead(error) {
            this.promptErrors(error.response.data.message);
        },
        redirectToPage() {
            const route = getRoute({
                name: this.notification.route_name,
                parameters: JSON.parse(this.notification.route_parameters)
            });
            this.$router.push(route);
        },
    },
    
    mixins: [mixins],

    props: {
        notif: [Object],
    },

    mounted() {
        this.notification = { ...this.notif }
    }
}
</script>